import React, { Component } from "react";
import {
  NormalTable,
  InputSearch,
  NormalSelect,
  NormalButtonBackend,
} from "component/common";
import { withTranslation } from "react-i18next";
import { ItemBrands } from "redux/actions/Backend";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import "../style.scss";

export class BrandlistClass extends Component {
  state = {
    headerDetails: [
      {
        label: "Code",
        divClass: "justify-content-end",
        sortKey: "Code",
        enabled: true,
        id: "itmCode",
        singleClickFunc: () => this.handleSort("itmCode"),
      },
      {
        label: "Description",
        sortKey: "Description",
        enabled: true,
        id: "itmDesc",
        singleClickFunc: () => this.handleSort("itmDesc"),
      },
      {
        label: "Active",
        sortKey: "Active",
        enabled: true,
        id: "itmStatus",
        singleClickFunc: () => this.handleSort("itmStatus"),
      },
      {
        label: "Show on retail",
        sortKey: "Show on retail",
        enabled: true,
        id: "retailProductBrand",
        singleClickFunc: () => this.handleSort("retailProductBrand"),
      },
      {
        label: "Show on voucher",
        sortKey: "Show on voucher",
        enabled: true,
        id: "voucherBrand",
        singleClickFunc: () => this.handleSort("voucherBrand"),
      },
      {
        label: "Show on prepaid",
        sortKey: "Show on prepaid",
        enabled: true,
        id: "prepaidBrand",
        singleClickFunc: () => this.handleSort("prepaidBrand"),
      },
    ],
    option: [
      { label: 10, value: 10 },
      { label: 25, value: 25 },
      { label: 50, value: 50 },
      { label: 100, value: 100 },
    ],
    count: 10,
    is_loading: false,
    isoption: false,
    offset: 0,
    data: [],
    perPage: 10,
    List: [],
    currentPage: 1,
    seachdata: [],
    filterdata: [],
    search: "",
    pageMeta: {},
    brandList: [],
    activeButton: false,
    inactiveButton: false,
    isActive: false,
    isInactive: false,
    isAll: false,
    orderBy: "desc",
  };

  componentDidMount = () => {
    this.Listofbrands({});
  };

  updateState = (data) => {
    if (this.state.isMounted) this.setState(data);
  };

  /* List Sorting */
  handleSort = (sortkey, order) => {
    let { List, headerDetails, orderBy } = this.state;
    this.setState({
      orderBy: this.state.orderBy == "asc" ? "desc" : "asc",
    });
    if (orderBy === "asc") {
      List.sort((a, b) =>
        a[sortkey] > b[sortkey] ? 1 : b[sortkey] > a[sortkey] ? -1 : 0
      );
    } else {
      List.sort((a, b) =>
        a[sortkey] < b[sortkey] ? 1 : b[sortkey] < a[sortkey] ? -1 : 0
      );
    }
    this.setState({
      List,
    });
  };

  /* List of Brand Function */
  Listofbrands = async () => {
    this.setState({
      is_loading: true,
      activeButton: false,
      inactiveButton: false,
    });
    await this.props.ItemBrands().then((res) => {
      let {
        brandList,
        pageCount,
        List,
        pageMeta,
        count,
        currentPage,
        perPage,
      } = this.state;
      brandList = res;
      List = brandList.slice(
        (currentPage - 1) * perPage,
        (currentPage - 1) * perPage + perPage
      );
      console.log(List, "listt");
      pageCount = Math.ceil(brandList.length / this.state.perPage);
      this.setState({
        brandList,
        List,
        pageCount,
        is_loading: false,
        isActive: false,
        isInactive: false,
        isAll: true,
        pageMeta: { ...pageMeta, total_pages: pageCount, per_page: count },
      });
    });
  };

  /* List of Brand Active List */
  Listofactivedept = async () => {
    this.setState({
      is_loading: true,
      activeButton: true,
      inactiveButton: false,
    });
    await this.props.ItemBrands().then((res) => {
      let { pageCount, List, currentPage, perPage, pageMeta } = this.state;
      let Listone = [];
      for (let key of res) {
        if (key.itmStatus === true) {
          Listone.push({
            itmCode: key.itmCode,
            itmDesc: key.itmDesc,
            voucherBrand: key.voucherBrand,
            itmStatus: key.itmStatus,
            retailProductBrand: key.retailProductBrand,
            prepaidBrand: key.prepaidBrand,
          });
        }
      }
      this.setState({ Listone });
      List = Listone.slice(
        (currentPage - 1) * perPage,
        (currentPage - 1) * perPage + perPage
      );
      pageCount = Math.ceil(Listone.length / this.state.perPage);
      this.setState({
        pageCount,
        is_loading: false,
        List,
        isActive: true,
        isInactive: false,
        isAll: false,
        pageMeta: { ...pageMeta, total_pages: pageCount },
      });
    });
  };

  /* List of Brand InActive List */
  Listofinactivebrand = async () => {
    this.setState({
      is_loading: true,
      activeButton: false,
      inactiveButton: true,
    });
    await this.props.ItemBrands().then((res) => {
      let { pageCount, List, currentPage, perPage, pageMeta } = this.state;
      let Listone = [];
      for (let key of res) {
        if (key.itmStatus === false) {
          Listone.push({
            itmCode: key.itmCode,
            itmDesc: key.itmDesc,
            voucherBrand: key.voucherBrand,
            itmStatus: key.itmStatus,
            retailProductBrand: key.retailProductBrand,
            prepaidBrand: key.prepaidBrand,
          });
        }
      }
      this.setState({ Listone });
      List = Listone.slice(
        (currentPage - 1) * perPage,
        (currentPage - 1) * perPage + perPage
      );
      pageCount = Math.ceil(Listone.length / this.state.perPage);
      this.setState({
        pageCount,
        is_loading: false,
        List,
        isActive: false,
        isInactive: true,
        isAll: false,
        pageMeta: { ...pageMeta, total_pages: pageCount },
      });
    });
  };

  /* Pagination Limit Set Function */
  temp = ({ target: { value, name } }) => {
    let { count, perPage, pageMeta } = this.state;
    if (name == "count") {
      count = value;
      perPage = +value;
      this.setState({
        count,
        perPage,
        pageMeta: { ...pageMeta, per_page: +perPage },
      });
      this.Listofbrands();
    }
  };

  /* page click function */
  handlePageClick = (e) => {
    let { isActive, isInactive, isAll } = this.state;
    const selectedPage = e.page;
    const offset = selectedPage * this.state.perPage;
    this.setState(
      {
        currentPage: selectedPage,
        pageMeta: { ...this.state.pageMeta, current_page: selectedPage },
        offset: offset,
      },
      () => {
        if (isActive) {
          this.Listofactivedept();
        } else if (isInactive) {
          this.Listofinactivedept();
        } else if (isAll) {
          this.Listofbrands();
        } else {
          this.handleFilterChange();
        }
      }
    );
  };

  handleFilterChange = () => {
    let {
      brandList,
      pageCount,
      filterdata,
      search,
      seachdata,
      perPage,
      currentPage,
      pageMeta,
      count,
    } = this.state;
    filterdata = brandList.filter((item) => {
      return Object.values(item)
        .join("")
        .toLowerCase()
        .includes(search.toLowerCase());
    });
    this.setState({ filterdata });
    seachdata = filterdata.slice(
      (currentPage - 1) * perPage,
      (currentPage - 1) * perPage + perPage
    );
    pageCount = Math.ceil(filterdata.length / this.state.perPage);
    this.setState({
      seachdata,
      pageCount,
      pageMeta: { ...pageMeta, total_pages: pageCount, perPage: count },
    });
  };

  /* Description Filter Function */
  filterByName = ({ target: { value, name } }) => {
    let {
      brandList,
      pageCount,
      filterdata,
      search,
      seachdata,
      activeButton,
      inactiveButton,
      pageMeta,
      perPage,
      count,
      currentPage,
    } = this.state;
    if (name === "search") {
      search = value;
      this.setState({ search });
    }
    if (search.length === 0) {
      this.Listofbrands();
    }
    if (search !== "") {
      filterdata = brandList.filter((item) => {
        const isActive = item.itmStatus ? "Yes" : "No";
        const lowerCaseSearch = search.toLowerCase();
        const lowerCaseCode = item.itmCode.toLowerCase();
        const lowerCaseDesc = item.itmDesc.toLowerCase();
        const lowerCasevoucherBrand = String(item.voucherBrand).toLowerCase();
        const lowerCaseretailProductBrand = String(
          item.retailProductBrand
        ).toLowerCase();
        const lowerCaseprepaidBrand = String(item.prepaidBrand).toLowerCase();
        const lowerCaseActive = isActive.toLowerCase();

        if (activeButton && item.itmStatus === false) {
          return false;
        }

        if (inactiveButton && item.itmStatus === true) {
          return false;
        }
        return (
          lowerCaseCode.includes(lowerCaseSearch) ||
          lowerCaseDesc.includes(lowerCaseSearch) ||
          lowerCasevoucherBrand.includes(lowerCaseSearch) ||
          lowerCaseretailProductBrand.includes(lowerCaseSearch) ||
          lowerCaseprepaidBrand.includes(lowerCaseSearch) ||
          lowerCaseActive.includes(lowerCaseSearch)
        );
      });
    } else {
      filterdata = brandList;
    }
    this.setState({ filterdata });
    if (filterdata.length < 10) {
      seachdata = filterdata;
    } else {
      seachdata = filterdata.slice(
        (currentPage - 1) * perPage,
        (currentPage - 1) * perPage + perPage
      );
    }
    pageCount = Math.ceil(filterdata.length / this.state.perPage);
    this.setState({
      seachdata,
      pageCount,
      isActive: false,
      isAll: false,
      isInactive: false,
      pageMeta: { ...pageMeta, total_pages: pageCount, perPage: count },
    });
  };

  render() {
    let {
      headerDetails,
      List,
      is_loading,
      option,
      pageMeta,
      count,
      search,
      filterdata,
      isActive,
      isAll,
      isInactive,
    } = this.state;
    let { t } = this.props;
    return (
      <>
        <div className="container-fluid department-container bg-white">
          <div className="row">
            <div className={"itemmaster-container col-12"}>
              <div className="align-items-center">
                <div className="col-12">
                  <h4 className="label-head text-center text-md-left text-lg-left mt-3 mb-0">
                    {t("Item Classification")}
                  </h4>
                </div>
                <div className="col-12">
                  <p className="label-title text-center text-md-left text-lg-left mt-2">
                    {t("Brand")}
                  </p>
                </div>
                <div className="mt-3 col-12 d-md-flex justify-content-md-between m-0 p-0">
                  <div className="d-md-flex col-12 col-md-4">
                    <div className="p-1">
                      <NormalButtonBackend
                        mainbg={true}
                        label={"All"}
                        onClick={this.Listofbrands}
                        isActive={isAll}
                      />
                    </div>
                    <div className="p-1">
                      <NormalButtonBackend
                        mainbg={true}
                        label={"Active"}
                        isActive={isActive}
                        onClick={this.Listofactivedept}
                      />
                    </div>
                    <div className="p-1">
                      <NormalButtonBackend
                        mainbg={true}
                        label={"Inactive"}
                        isActive={isInactive}
                        onClick={this.Listofinactivebrand}
                      />
                    </div>
                  </div>
                  <div className="p-1 col-12 col-md-4">
                    <InputSearch
                      type="search"
                      placeholder={t("Search")}
                      onChange={this.filterByName}
                    />
                  </div>
                </div>
                <div className="d-flex justify-content-center justify-content-md-start col-12 mt-4">
                  <p className="mt-2 mr-1">{t("Show")}</p>
                  <div className="p-1">
                    <NormalSelect
                      options={option}
                      value={count}
                      onChange={this.temp}
                      name="count"
                    />
                  </div>
                  <p className="mt-2 ml-1">{t("Entries")}</p>
                </div>
              </div>
              <div className="tab-table-content">
                {search.length > 0 ? (
                  <div className="table-container">
                    <div className="py-4">
                      <div className="table-container">
                        <NormalTable
                          headerDetails={headerDetails}
                          pageMeta={pageMeta}
                          queryHandler={(event) => this.handlePageClick(event)}
                        >
                          {is_loading ? (
                            <tr>
                              <td colSpan="7">
                                <div class="d-flex mt-5 align-items-center justify-content-center">
                                  <div class="spinner-border" role="status">
                                    <span class="sr-only">Loading...</span>
                                  </div>
                                </div>
                              </td>
                            </tr>
                          ) : filterdata.length > 0 ? (
                            filterdata.map(
                              (
                                {
                                  itmCode,
                                  itmDesc,
                                  itmStatus,
                                  retailProductBrand,
                                  voucherBrand,
                                  prepaidBrand,
                                },
                                index
                              ) => {
                                return (
                                  <tr key={index}>
                                    <td>
                                      <div
                                        className="text-left text-primary"
                                        onClick={() =>
                                          this.props.history.push(
                                            `/admin/backend/brandId/${itmCode}`
                                          )
                                        }
                                      >
                                        {itmCode}
                                      </div>
                                    </td>
                                    <td>
                                      <div className="text-left text-lowercase ">
                                        {itmDesc}
                                      </div>
                                    </td>
                                    <td>
                                      <div className="text-left">
                                        {itmStatus == true ? "yes" : "No"}
                                      </div>
                                    </td>
                                    <td>
                                      <div className="text-left">
                                        {retailProductBrand == true
                                          ? "yes"
                                          : "No"}
                                      </div>
                                    </td>
                                    <td>
                                      <div className="text-left">
                                        {voucherBrand == true ? "yes" : "No"}
                                      </div>
                                    </td>
                                    <td>
                                      <div className="text-left">
                                        {prepaidBrand == true ? "yes" : "No"}
                                      </div>
                                    </td>
                                  </tr>
                                );
                              }
                            )
                          ) : null}
                        </NormalTable>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="py-4">
                    <div className="table-container">
                      <NormalTable
                        headerDetails={headerDetails}
                        pageMeta={pageMeta}
                        queryHandler={(event) => this.handlePageClick(event)}
                      >
                        {is_loading ? (
                          <tr>
                            <td colSpan="7">
                              <div class="d-flex mt-5 align-items-center justify-content-center">
                                <div class="spinner-border" role="status">
                                  <span class="sr-only">Loading...</span>
                                </div>
                              </div>
                            </td>
                          </tr>
                        ) : List.length > 0 ? (
                          List.map(
                            (
                              {
                                itmCode,
                                itmDesc,
                                itmStatus,
                                retailProductBrand,
                                voucherBrand,
                                prepaidBrand,
                              },
                              index
                            ) => {
                              return (
                                <tr key={index}>
                                  <td>
                                    <div
                                      className="text-left text-primary"
                                      onClick={() =>
                                        this.props.history.push(
                                          `/admin/backend/brandId/${itmCode}`
                                        )
                                      }
                                    >
                                      {itmCode}
                                    </div>
                                  </td>
                                  <td>
                                    <div className="text-left">{itmDesc}</div>
                                  </td>
                                  <td>
                                    <div className="text-left">
                                      {itmStatus == true ? "yes" : "No"}
                                    </div>
                                  </td>
                                  <td>
                                    <div className="text-left">
                                      {retailProductBrand == true
                                        ? "yes"
                                        : "No"}
                                    </div>
                                  </td>
                                  <td>
                                    <div className="text-left">
                                      {voucherBrand == true ? "yes" : "No"}
                                    </div>
                                  </td>
                                  <td>
                                    <div className="text-left">
                                      {prepaidBrand == true ? "yes" : "No"}
                                    </div>
                                  </td>
                                </tr>
                              );
                            }
                          )
                        ) : null}
                      </NormalTable>
                    </div>
                  </div>
                )}
              </div>
              <div
                className="icon"
                onClick={() =>
                  this.props.history.push(
                    `/admin/backend/itemclassification/branddataentry`
                  )
                }
              >
                +
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      ItemBrands,
    },
    dispatch
  );
};

export const Brandlist = withTranslation()(
  connect(null, mapDispatchToProps)(BrandlistClass)
);
